import React from 'react';

import { useAuth } from '../../contexts/auth';
import MapRealTime from './map-real-time';

export default function MapRealTimeRoute() {
  const { subsidiaryId, subsidiaryGuid } = useAuth();
  const resolvedSubsidiaryId = subsidiaryId || subsidiaryGuid || null;

  return (
    <MapRealTime
      subsidiaryId={resolvedSubsidiaryId}
      title="Condutores em tempo real"
    />
  );
}
